import React, { useState, useEffect } from "react";
import { Autocomplete, Button, TextField } from "@mui/material";
import axios from "axios";
import { Spinner } from "../Spinner/Spinner";
import { set } from "date-fns";

const Topup = ({
  open,
  onClose,
  onApplyAction,
  groupedItemsToActivate,
  accountDetails,
  actionTargetField,
  actionId,
  isWhitelistIpChecked,
  isWhitelistNumberChecked,
  tempWhitelistIpGroup,
  tempWhitelistNumberGroup,
  getDataRequestIdByName,
  getSmsRequestIdByName,
  activateSimsWithWhitelisting,
  setIsWhitelistIpChecked,
  setIsWhitelistNumberChecked,
  setTempWhitelistIpGroup,
  setTempWhitelistNumberGroup,
  setShowPlanDetailsPopup,
  dataWhitelistOptions,
  smsWhitelistOptions,
  loadingDataWhitelistOptions,
  loadingSmsWhitelistOptions,
  setGroupedItemsToActivate,
}) => {
  const [selectedPlans, setSelectedPlans] = useState({});
const [loading, setLoading] = useState(false);  
  // Add custom scrollbar styles for webkit browsers
  useEffect(() => {
    const style = document.createElement('style');
    style.innerHTML = `
      .plan-scroll-container::-webkit-scrollbar {
        height: 8px;
      }
      .plan-scroll-container::-webkit-scrollbar-track {
        background: #f0f0f0;
        border-radius: 10px;
      }
      .plan-scroll-container::-webkit-scrollbar-thumb {
        background: #4151e0;
        border-radius: 10px;
      }
      .plan-scroll-container::-webkit-scrollbar-thumb:hover {
        background: #3a47d1;
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  useEffect(() => {
    setSelectedPlans({});
  }, [groupedItemsToActivate]);

  const handlePlanToggle = (account, planType) => {
    setSelectedPlans((prev) => {
      const current = prev[account];
      return {
        ...prev,
        [account]: current === planType ? null : planType,
      };
    });
  };

  const handleClosePlanDetailsPopup = async () => {
    let allItemsToUpdate = [];
  
    for (const accountName in groupedItemsToActivate) {
      const itemsInAccount = groupedItemsToActivate[accountName];
      const selectedPlanForAccount = selectedPlans[accountName];
  
      if (selectedPlanForAccount) {
        const selectedPlanDetails =
          accountDetails[accountName]?.[selectedPlanForAccount] || {};
  
        allItemsToUpdate = allItemsToUpdate.concat(
          itemsInAccount.map((item) => ({
            ...item,
            [actionTargetField]: actionId,
            selectedPlan: selectedPlanForAccount,
            validity: selectedPlanDetails.Valid_Upto || "",
            planData: selectedPlanDetails.data || "",
            planSms: selectedPlanDetails.sms || "",
            planCost: selectedPlanDetails.cost || "",
            planId: selectedPlanDetails.id,
          }))
        );
      } else {
        allItemsToUpdate = allItemsToUpdate.concat(itemsInAccount);
      }
    }
  
    if (allItemsToUpdate.length === 0) {
      setShowPlanDetailsPopup(false);
      setGroupedItemsToActivate({});
      setSelectedPlans({});
      return;
    }
  setLoading(true);
    try {
      let operationType = "TOPUP";
  
      if (isWhitelistIpChecked && isWhitelistNumberChecked) {
        operationType = "TOPUP+DATA+SMS";
      } else if (isWhitelistIpChecked && !isWhitelistNumberChecked) {
        operationType = "TOPUP+DATA";
      } else if (!isWhitelistIpChecked && isWhitelistNumberChecked) {
        operationType = "TOPUP+SMS";
      }
      debugger
  
      const simUpdatePayload = allItemsToUpdate.map((item) => {
        const payload = {
          msisdn: item.msisdn,
          profile: item.vendor,
          validity: item.validity,
          operationType: operationType,
          planId: item.planId,
        };
  
        if (isWhitelistIpChecked && tempWhitelistIpGroup) {
          payload.dataWhiteList = tempWhitelistIpGroup;
          const dataRequestId = getDataRequestIdByName(tempWhitelistIpGroup);
          if (dataRequestId) {
            payload.dataWhiteListRequestId = dataRequestId;
          }
        }
  
        if (isWhitelistNumberChecked && tempWhitelistNumberGroup) {
          payload.smsWhiteList = tempWhitelistNumberGroup;
          const smsRequestId = getSmsRequestIdByName(tempWhitelistNumberGroup);
          if (smsRequestId) {
            payload.smsWhiteListRequestId = smsRequestId;
          }
        }
  
        return payload;
      });
  
      console.log("Top-Up payload:", simUpdatePayload);
      const response = await activateSimsWithWhitelisting(simUpdatePayload);
      
      // Handle array response
      let alertMessage = "Top-Up completed";
      
      if (Array.isArray(response)) {
        // Extract messages from array
        const messages = response.map(item => item.message).filter(msg => msg);
        alertMessage = messages.length > 0 ? messages.join("\n") : "Top-Up successful";
      } else if (response.message) {
        // Single message response
        alertMessage = response.message;
      }
      
      alert(alertMessage);
      console.log("Top-Up API call successful");
  
      onApplyAction(allItemsToUpdate);
      setShowPlanDetailsPopup(false);
      setGroupedItemsToActivate({});
      setSelectedPlans({});
      setIsWhitelistIpChecked(false);
      setIsWhitelistNumberChecked(false);
      setTempWhitelistIpGroup("");
      setTempWhitelistNumberGroup("");
      onClose();
      setLoading(false);
    } catch (error) {
      console.error("API update failed", error);
      alert("Something went wrong while processing Top-Up.");
      setLoading(false);
    }
  };
  

  const grandTotal = Object.entries(groupedItemsToActivate).reduce(
    (acc, [accountName, items]) => {
      const selectedPlan = selectedPlans[accountName];
      const planCost = accountDetails[accountName]?.[selectedPlan]?.cost;
      const costValue = parseInt(planCost?.replace("₹", "")) || 0;
      return acc + costValue * items.length;
    },
    0
  );

  return (

    <>

      {loading && (
          <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 10001, // Higher than popup's 10000
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            backgroundColor: 'rgba(0, 0, 0, 0.7)'
          }}>
            <Spinner />
          </div>
        )}
    <div
      style={{
        position: "fixed",
        top: "50%",
        left: "50%",
        transform: "translate(-50%, -50%)",
        background: "white",
        padding: "0",
        borderRadius: "12px",
        boxShadow: "0 4px 15px rgba(0,0,0,0.3)",
        zIndex: 10000,
        width: "auto",
        minWidth: "800px",
        maxWidth: "90vw",
        minHeight: "50vh",
        maxHeight: "90vh",
        overflowY: "auto",
        textAlign: "center",
      }}
    >
      <div
        style={{
          backgroundColor: "#4151e0",
          color: "white",
          padding: "1rem 2rem",
          borderTopLeftRadius: "12px",
          borderTopRightRadius: "12px",
          fontWeight: "bold",
          fontSize: "1.25rem",
          textAlign: "center",
          display: "flex",
          justifyContent: "space-between",
        }}
      >
        Top Up Plan Details
        <span>
          <button
            style={{
              marginBottom: "1.5rem",
              padding: "0.8rem 2rem",
              borderRadius: "8px",
              border: "none",
              background: "rgb(12, 29, 180)",
              color: "white",
              fontWeight: "bold",
              fontSize: "1rem",
              cursor: "pointer",
              transition: "all 0.3s ease",
            }}
            onClick={() => {
              onClose();
            }}
          >
            close
          </button>
        </span>
      </div>

      <div style={{ padding: "2rem", width: "100%" }}>
                  {Object.entries(groupedItemsToActivate).map(
          ([accountName, itemsInAccount]) => {
            const plans = accountDetails[accountName] || {};
            const selectedPlan = selectedPlans[accountName];

            // Filter to get only TopUp plans
            const topUpPlanKeys = Object.keys(plans).filter(
              (planKey) => plans[planKey]?.planType === "TopUp"
            );

            // Skip this account if no TopUp plans available
            if (topUpPlanKeys.length === 0) return null;

            const renderPlan = (planType) => {
              const plan = plans[planType];

              // Filter to show only TopUp plans
              if (!plan || plan.planType !== "TopUp") return null;

              const isSelected = selectedPlan === planType;

              return (
                <div
                  key={planType}
                  style={{
                    border: isSelected
                      ? "2px solid #4151e0"
                      : "1px dashed #aaa",
                    padding: "0.75rem",
                    borderRadius: "8px",
                    marginRight: "1rem",
                    backgroundColor: isSelected ? "#e7ebff" : "#f9f9f9",
                    cursor: "pointer",
                    transition: "all 0.3s ease",
                    transform: isSelected ? "scale(1.02)" : "scale(1)",
                    boxShadow: isSelected
                      ? "0 2px 8px rgba(65, 81, 224, 0.3)"
                      : "none",
                    minWidth: "220px",
                    flexShrink: 0,
                  }}
                  onClick={() => handlePlanToggle(accountName, planType)}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginBottom: "0.5rem",
                    }}
                  >
                <input
  type="radio"
  name={accountName}
  checked={selectedPlans[accountName] === planType}
  onClick={(e) => {
    e.stopPropagation();
    // Allow deselect when clicking the same radio again
    if (selectedPlans[accountName] === planType) {
      setSelectedPlans((prev) => ({ ...prev, [accountName]: null }));
    } else {
      handlePlanToggle(accountName, planType);
    }
  }}
  readOnly
  style={{
    marginRight: "0.5rem",
    transform: "scale(1.3)",
    accentColor: "#4151e0",
    cursor: "pointer",
  }}
/>


                    <strong
                      style={{
                        color: isSelected ? "#4151e0" : "#333",
                        fontSize: "1rem",
                        transition: "color 0.3s ease",
                      }}
                    >
                      {plan.planName}
                    </strong>
                    {isSelected && (
                      <span
                        style={{
                          marginLeft: "auto",
                          color: "#4151e0",
                          fontSize: "0.9rem",
                          fontWeight: "bold",
                          animation: "fadeIn 0.3s ease",
                        }}
                      >
                        ✓ Selected
                      </span>
                    )}
                  </div>

                  <div
                    style={{
                      marginLeft: "1.5rem",
                      marginTop: "0.5rem",
                      textAlign: "left",
                      opacity: isSelected ? 1 : 0.8,
                      transition: "opacity 0.3s ease",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "0.3rem",
                      }}
                    >
                      <strong style={{ color: "#555" }}>DATA:</strong>
                      <span style={{ color: "#333", fontWeight: "500" }}>
                        {plan.data}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "0.3rem",
                      }}
                    >
                      <strong style={{ color: "#555" }}>SMS:</strong>
                      <span style={{ color: "#333", fontWeight: "500" }}>
                        {plan.sms}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "0.3rem",
                      }}
                    >
                      <strong style={{ color: "#555" }}>Validity:</strong>
                      <span style={{ color: "#333", fontWeight: "500" }}>
                        {plan.Valid_Upto}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        marginBottom: "0.3rem",
                      }}
                    >
                      <strong style={{ color: "#555" }}>Plan Type:</strong>
                      <span style={{ color: "#333", fontWeight: "500" }}>
                        {plan.planType}
                      </span>
                    </div>
                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                      }}
                    >
                      <strong style={{ color: "#555" }}>COST:</strong>
                      <span
                        style={{
                          color: "#4151e0",
                          fontWeight: "bold",
                          fontSize: "1.1rem",
                        }}
                      >
                        {plan.cost}
                      </span>
                    </div>
                  </div>
                </div>
              );
            };

            return (
              <div
                key={accountName}
                style={{
                  paddingBottom: "1.5rem",
                  borderBottom: "1px solid #ddd",
                  marginBottom: "1.5rem",
                  textAlign: "left",
                }}
              >
                <div style={{ marginBottom: "1rem" }}>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <strong style={{ color: "#333" }}>Account:</strong>
                    <span style={{ color: "#4151e0", fontWeight: "600" }}>
                      {accountName || "N/A"}
                    </span>
                  </div>
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginBottom: "0.5rem",
                    }}
                  >
                    <strong style={{ color: "#333" }}>
                      Items to Top Up:
                    </strong>
                    <span style={{ color: "#666" }}>
                      {itemsInAccount.length}
                    </span>
                  </div>
                </div>

                <div style={{ marginBottom: "1rem", width: "100%", overflow: "hidden" }}>
                  <h4
                    style={{
                      color: "#333",
                      marginBottom: "0.8rem",
                      fontSize: "1.1rem",
                      fontWeight: "600",
                    }}
                  >
                    Available Top-Up Plans:
                  </h4>
                  <div
                    className="plan-scroll-container"
                    style={{
                      display: "flex",
                      gap: "1rem",
                      overflowX: "auto",
                      paddingBottom: "1rem",
                      scrollbarWidth: "thin",
                      scrollbarColor: "#4151e0 #f0f0f0",
                      width: "100%",
                    }}
                  >
                    {topUpPlanKeys.map((planName) =>
                      renderPlan(planName)
                    )}
                  </div>
                </div>

                {selectedPlans[accountName] && (
                  <button
                    style={{
                      marginTop: "0.5rem",
                      fontSize: "0.85rem",
                      background:
                        "linear-gradient(45deg, #ff6b6b, #ee5a5a)",
                      border: "none",
                      color: "white",
                      cursor: "pointer",
                      padding: "0.4rem 0.8rem",
                      borderRadius: "6px",
                      fontWeight: "500",
                      transition: "all 0.3s ease",
                      boxShadow: "0 2px 4px rgba(238, 90, 90, 0.3)",
                    }}
                    onClick={() =>
                      setSelectedPlans((prev) => ({
                        ...prev,
                        [accountName]: null,
                      }))
                    }
                  >
                    Clear Selection
                  </button>
                )}
              </div>
            );
          }
        )}
      </div>
      <div
        style={{
          padding: "1rem",
          textAlign: "center",
          fontWeight: "bold",
          fontSize: "1.5rem",
        }}
      >
        Total Payable Amount: ₹{grandTotal}
      </div>
      <button
        style={{
          marginBottom: "2.5rem",
          padding: "0.8rem 2rem",
          borderRadius: "8px",
          border: "none",
          background: "linear-gradient(45deg, #4151e0, #3a47d1)",
          color: "white",
          fontWeight: "bold",
          fontSize: "1rem",
          cursor: "pointer",
          transition: "all 0.3s ease",
          boxShadow: "0 4px 8px rgba(65, 81, 224, 0.3)",
        }}
        onClick={handleClosePlanDetailsPopup}
      >
       Confirm
      </button>
    </div>
    </>
  );
};

export default Topup;